import { Injectable, signal } from '@angular/core';
import { ApiHistory } from '@layout/models/api-history';

@Injectable({
  providedIn: 'root'
})
export class ApiHistoryService {

  lstApiHistory = signal<ApiHistory[]>([])

  add(item: ApiHistory){
    this.lstApiHistory.update( lst => [item, ...lst].slice(0, 20) )
  }

  clear(){
    this.lstApiHistory.set([])
  }

}
